<template>
  <b-navbar :spaced="false" :shadow="true">
    <template slot="brand">
      <b-navbar-item>
        Memegen
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>

export default {
  name: "Navbar"
};

</script>

<style scoped>

</style>